import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m9 9 5 12 1.774-5.226L21 14 9 9z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16.071 16.071 4.243 4.243", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m7.188 2.239.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656-2.12 2.122",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "MousePointerClick";
const MousePointerClick = memo(themed(Icon));
export {
  MousePointerClick
};
//# sourceMappingURL=mouse-pointer-click.js.map
